import { Either, left, right } from "fp-ts/lib/Either";
import ErrorEntity from "../../../../domain/entities/error.entity";
import { HumanRanking, Target } from "../../../../domain/repositories/dashboard.repository";
import DateDto from "../../../dto/date.dto";
import di from "../../../../dependency_injection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import HumanRankingDto from "../../../dto/human_ranking.dto";
import SearchResultEntity from "../../../../domain/entities/search_result.entity";

const searchRankingAgentsApiImpl = async (_: {
    query?: string, initDate?: Date, endDate?: Date,
    page: number, itemsPerPage: number, sortBy: "ASC" | "DESC",  sortField?: "average_score" | "total_calls_evaluated" | "name", aiAgentId?: String
}): Promise<Either<ErrorEntity, SearchResultEntity<HumanRanking>>> => {
    const realSort = _.sortBy == "ASC" ? "DESC": "ASC"; //It orders by score not by ranking
    try {
        console.log("searchRankingAgentsApiImpl", _);
        let relativeUrl = `/stats/human-agents-ranking-paged?sort=${realSort}&page_number=${_.page}&page_size=${_.itemsPerPage}`;
        if(_.query) relativeUrl += `&name=${_.query}`;
        if (_.initDate) relativeUrl += `&start_date=${DateDto.toServer(_.initDate)}`;
        if (_.endDate) relativeUrl += `&end_date=${DateDto.toServer(_.endDate)}`;
        if (_.sortField) relativeUrl += `&sort_by=${_.sortField}`;
        if(_.aiAgentId) relativeUrl += `&agent_id=${_.aiAgentId}`;
        const response = await di.get<HostApi>(HostApiName).get(relativeUrl, {
            contentType: 'application/json',
        });
        const parsed = response.content.map((item: any) => HumanRankingDto.fromJSON(item));
        return right({
            data: parsed,
            total: response.total_elements,
            page: response.number,
            itemsPerPage: response.size,
            pages: response.total_pages,
        });

    } catch (error) {
        console.log("error", error)
        return left(ErrorEntity.fromError(error));
    }
}

export default searchRankingAgentsApiImpl;